// No import of featureFlags — the metric sink is INJECTED.
export const FUNNEL = {
  LANDING_VIEWED: 'LANDING_VIEWED',
  CTA_CLICKED: 'CTA_CLICKED',
  REDIRECT_INITIATED: 'REDIRECT_INITIATED',
  FAILED: 'FAILED',
  WELCOME_VIEWED: 'WELCOME_VIEWED',
  ORGANISATION_SUBMITTED: 'ORGANISATION_SUBMITTED',
  ORGANISATION_CREATED: 'ORGANISATION_CREATED',
  TRIAL_SIGNUP_STARTED: 'TRIAL_SIGNUP_STARTED',
  TRIAL_AUTOSTARTED: 'TRIAL_AUTOSTARTED',
  TRIAL_AUTOSTART_SKIPPED: 'TRIAL_AUTOSTART_SKIPPED',
} as const;
export type FunnelStage = (typeof FUNNEL)[keyof typeof FUNNEL];

const KEYS: Record<FunnelStage, string> = {
  LANDING_VIEWED: 'enterprise-hub-signup-landing-viewed',
  CTA_CLICKED: 'enterprise-hub-signup-cta-clicked',
  REDIRECT_INITIATED: 'enterprise-hub-signup-redirect-initiated',
  FAILED: 'enterprise-hub-signup-failed',
  WELCOME_VIEWED: 'enterprise-hub-signup-welcome-viewed',
  ORGANISATION_SUBMITTED: 'enterprise-hub-signup-organisation-submitted',
  ORGANISATION_CREATED: 'enterprise-hub-signup-organisation-created',
  TRIAL_SIGNUP_STARTED: 'enterprise-hub-trial-signup-started',
  TRIAL_AUTOSTARTED: 'enterprise-hub-trial-autostarted',
  TRIAL_AUTOSTART_SKIPPED: 'enterprise-hub-trial-autostart-skipped',
};

// Pure: stage → LaunchDarkly metric key.
export function funnelMetricKey(stage: FunnelStage): string {
  return KEYS[stage];
}

export type FunnelData = Record<string, string>;
export type Track = (metricKey: string, data?: FunnelData) => void;

// Adapter: record the funnel metric via the injected track fn (no-op if null).
export function trackFunnel(stage: FunnelStage, track: Track | null | undefined, data?: FunnelData): void {
  if (!track) return;
  if (data) track(funnelMetricKey(stage), data);
  else track(funnelMetricKey(stage));
}
